import SelectController from "@/common/components/SelectController";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { BulkActionEntryInspectData } from "@/common/types/bulkActions/entryInspect.type";
import { useCompanies } from "@/features/companies/hooks/useCompanies";
import { CompaniesTransformer } from "@/features/companies/services/companiesTransformer";
import { useFormContext } from "react-hook-form";

type BulkActionGlobalColumnFieldProps = BulkActionEntryInspectData['global_columns'][0] & {
  disabledFromDefaultValue?: boolean;
}

export const bulkActionsGlobalColumnsFields = {
  client_company_id: ({ required, disabledFromDefaultValue }: BulkActionGlobalColumnFieldProps) => {
    const { control } = useFormContext();

    const [searchClientCompany, setSearchClientCompany] = useDebounce('');

    const { data: companiesOptions, isFetching: isCompaniesFetching } = useCompanies({
      filters: {
        search: searchClientCompany,
      },
      mapper: Mapper.mapWithTransformer({ transformer: CompaniesTransformer.optionsTransformer() }),
    });

    return (
      <SelectController
        control={control}
        name="client_company_id"
        label="Empresa cliente"
        options={companiesOptions as { value: string, label: string }[]}
        onInputChange={setSearchClientCompany}
        isLoading={isCompaniesFetching}
        markAsRequired={required}
        isClearable
        isDisabled={disabledFromDefaultValue}
      />
    )
  }
};
